import React from 'react';

export default function PhoneCallIcon({
  width = 21,
  height = 20,
  className,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_12014_29782)">
        <path
          d="M2.9104 1.65088C4.39045 1.41785 6.48723 3.26241 7.37391 4.32672C8.0423 5.12911 9.13803 6.73204 8.65473 7.79266C8.44628 8.25011 7.84799 8.78565 7.45077 9.09431C7.28967 9.21974 6.64833 9.58865 6.62005 9.73499C6.59176 9.88132 6.64403 10.0885 6.67846 10.2312C6.99575 11.5636 8.72052 13.2864 9.98905 13.7604C10.2202 13.8471 10.7281 14.0316 10.9323 13.8471C11.3904 13.1155 12.3306 11.7702 13.2806 11.7388C15.3183 11.6712 18.6781 15.1322 18.897 17.101C19.0556 18.5262 17.3038 19.5401 16.1171 19.8266C11.7446 20.8823 6.98407 16.8796 4.29207 13.8496C2.10612 11.3883 -0.280276 7.56517 0.745365 4.13796C1.01899 3.22245 1.87923 1.8132 2.91102 1.65088H2.9104ZM3.22769 2.92178C3.0426 2.96236 2.53962 3.44994 2.40496 3.61103C0.234389 6.20511 3.42999 10.8909 5.18858 12.9538C7.24786 15.3695 11.803 19.1287 15.1492 18.8594C15.9959 18.7912 16.9226 18.3251 17.4133 17.6242C17.6709 17.2565 17.6205 17.1563 17.4668 16.7425C17.0296 15.565 14.7834 13.2243 13.5093 13.065C13.1391 13.0189 12.9153 13.3116 12.6835 13.5711C12.2408 14.0666 11.9376 14.8672 11.3117 15.1021C10.1323 15.5441 8.5957 14.5825 7.71394 13.849C6.59299 12.9156 4.87129 10.7729 5.43515 9.2265C5.65651 8.61841 6.47494 8.26917 6.9564 7.84431C7.14701 7.67645 7.50304 7.3721 7.49566 7.11202C7.46368 6.04463 5.70079 4.26647 4.86638 3.65346C4.52757 3.40444 3.63721 2.83263 3.2283 2.9224L3.22769 2.92178Z"
          fill="currentColor"
        />
        <path
          d="M11.9081 8.60059C10.8812 8.55632 10.0437 7.72627 9.96504 6.70623C10.0474 5.17401 9.83714 3.49484 9.96073 1.97984C10.0364 1.04956 10.6783 0.31358 11.5804 0.0996105C13.7989 0.117441 16.205 -0.0916094 18.413 0.0485776C19.5033 0.118056 20.2786 0.771032 20.4594 1.85994C20.3647 3.47455 20.5867 5.23488 20.4613 6.83166C20.4096 7.48525 19.9331 8.13822 19.3483 8.42229C18.469 8.85023 17.2017 8.52989 16.2431 8.65778C15.1326 9.28308 14.086 10.1476 12.9805 10.7637C12.8747 10.8227 12.772 10.894 12.646 10.9075C11.5146 11.025 12.02 9.25418 11.9093 8.59998L11.9081 8.60059ZM13.1815 7.78468C13.2418 8.14622 13.1373 8.65839 13.1815 9.03714L15.8471 7.34813C16.6981 7.17106 17.6764 7.37949 18.5305 7.28788C18.94 7.24422 19.1362 6.9079 19.2087 6.53407C19.1386 5.12175 19.3643 3.48869 19.2259 2.0985C19.181 1.64843 18.9117 1.349 18.4524 1.32133L11.8589 1.33239C11.5318 1.40802 11.2981 1.64904 11.2366 1.9823L11.2428 6.66196C11.3528 7.07637 11.6375 7.25099 12.0489 7.28726C12.269 7.30694 12.5359 7.25222 12.7456 7.30632C12.9159 7.35059 13.1533 7.61252 13.1822 7.78468H13.1815Z"
          fill="currentColor"
        />
        <path
          d="M17.2669 3.67866C17.6758 3.60426 18.2237 3.69403 18.3018 4.17608C18.4531 5.10881 16.9416 5.21826 16.7781 4.42694C16.7123 4.10906 16.9398 3.7383 17.2669 3.67866Z"
          fill="currentColor"
        />
        <path
          d="M14.9604 3.67867C15.3822 3.60797 15.8625 3.6799 15.9775 4.15334C16.1429 4.83768 15.2857 5.12789 14.7698 4.84382C14.2551 4.56038 14.4052 3.77152 14.9604 3.67806V3.67867Z"
          fill="currentColor"
        />
        <path
          d="M12.6534 3.67807C13.1969 3.56801 13.7965 3.8035 13.6956 4.44233C13.6015 5.03567 12.5562 5.12175 12.2482 4.62187C12.0311 4.26895 12.2476 3.76046 12.6534 3.67807Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_12014_29782">
          <rect width="20" height="20" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
